import { addTracking as t } from "@sunrise/tracking";
import { defineComponent as e } from "vue";
const o = e({
  name: "MsClickArea",
  props: {
    href: {
      required: !0,
      type: String
    },
    target: {
      default: "_self",
      type: String
    },
    rel: String,
    trackingData: Array
  },
  setup(r) {
    return {
      tracking: t(r.trackingData)
    };
  }
});
export {
  o as default
};
